import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ReportResult} from '../_models/ReportResult';
import {firstValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ReportService {
  constructor(private http: HttpClient) {}

  async getReportBase64(orgId: number, reportName: string, nomeFiltro: string, valoreFiltro: string) {
    return firstValueFrom(this.http.post<ReportResult>(`${environment.localApiUrl}api/Report/GetReportBase64/${orgId}`,
      {reportName, nomeFiltro, valoreFiltro}));
  }

  base64ToPDF(base64String: string) {
    // Decodifica la stringa Base64
    const byteCharacters = atob(base64String);
    // Converti in array di byte
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    // Crea un blob dal byte array con il MIME type per PDF
    const blob = new Blob([byteArray], {type: 'application/pdf'});
    // Crea un URL temporaneo per il file Blob
    const url = URL.createObjectURL(blob);
    // Apri il PDF in una nuova finestra o scheda
    window.open(url);

    // (Opzionale) libera l'URL temporaneo dopo un po' di tempo
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 10000); // Ad esempio dopo 10 secondi
  }

  // Scarica il blob come file: aprendolo nel lettore PDF di sistema il formato pagina reale
  // (MediaBox) viene rispettato in stampa, a differenza del viewer del browser che forza l'A4.
  downloadPdf(blob: Blob, fileName: string) {
    const safeName = fileName?.toLowerCase().endsWith('.pdf') ? fileName : `${fileName || 'report'}.pdf`;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    // Con <a download> su object URL il nome qui impostato prevale sul Content-Disposition del backend.
    link.download = safeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }
}
